import React from 'react';
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { ReCaptcha } from 'react-recaptcha-v3';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { DatePicker } from '@material-ui/pickers';
import { googleRecaptcha } from '../../helpers';

class AddChildDialog extends React.Component {
  constructor(props) {
    super(props);
    let minDate = new Date();
    minDate.setFullYear(1995);

    this.state = {
      code: '',
      isDobDialogOpen: false,
      dob: null,
      minDate: minDate,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
    this.onDialogButtonClick = this.onDialogButtonClick.bind(this);
    this.onDobDialogClose = this.onDobDialogClose.bind(this);
    this.onDobDialogButtonClick = this.onDobDialogButtonClick.bind(this);
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onDialogClose() {
    this.setState({
      code: '',
    });

    if (this.props.onDialogClose) {
      this.props.onDialogClose();
    }
  }

  onDialogButtonClick() {
    const {
      enqueueSnackbar,
      t,
    } = this.props;

    axios
      .post(`${window.apiUrl}/hasdob`, qs.stringify({
        code: this.state.code,
      }))
      .then((response) => {
        if (response.data.data.already_added === true) {
          enqueueSnackbar(t('The pupil was already added to your account.'), {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else if (response.data.data.has_dob) {
          this.setState({
            isDobDialogOpen: true,
          });
        } else {
          googleRecaptcha('parent_add_pupil', (token) => {
          axios
            .post(`${window.apiUrl}/addchild`, qs.stringify({
              code: this.state.code,
              'recaptcha-token': token,
            }))
            .then((addChildResponse) => {
              if (addChildResponse.data.success) {
                enqueueSnackbar(t('You have successfully added a child.'), {
                  variant: 'success',
                  autoHideDuration: 2000,
                });

                this.setState({
                  code: '',
                });

                if (this.props.onPupilAdded) {
                  this.props.onPupilAdded();
                }
              } else {
                enqueueSnackbar(addChildResponse.data.error, {
                  variant: 'error',
                  autoHideDuration: 2000,
                });
              }
            })
            .catch((thrown) => {});
          });
        }
      });
  }

  onDobDialogClose() {
    this.setState({
      isDobDialogOpen: false,
    });
  }

  onDobDialogButtonClick() {
    const {
      enqueueSnackbar,
      t,
    } = this.props;

    googleRecaptcha('parent_add_pupil', (token) => {
    axios
      .post(`${window.apiUrl}/addchild`, qs.stringify({
        code: this.state.code,
        dob: this.state.dob
          ? this.state.dob.format('YYYY-MM-DD')
          : '',
        'recaptcha-token': token,
      }))
      .then((response) => {
        const { data } = response;
        if (data.success) {
          enqueueSnackbar(t('You have successfully added a child.'), {
            variant: 'success',
            autoHideDuration: 2000,
          });

          this.setState({
            isDobDialogOpen: false,
            code: '',
          });

          if (this.props.onPupilAdded) {
            this.props.onPupilAdded();
          }
        } else {
          enqueueSnackbar(data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      }).catch((thrown) => {});
    });
  }

  render() {
    const {
      code,
      isDobDialogOpen,
      dob,
    } = this.state;
    const {
      t,
      isDialogOpen,
    } = this.props;

    return (
      <>
        <Dialog
          open={isDialogOpen}
          onClose={this.onDialogClose}
          aria-labelledby="form-dialog-title"
          className="add-child-dialog"
        >
          <DialogTitle id="form-dialog-title">
            {t('Add a child to your account')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t('Please enter the parent code supplied by the school to add a new child.')}
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label={t('Code')}
              fullWidth
              name="code"
              value={code}
              autoComplete="off"
              onChange={this.onInputChange}
              onInput={e => {
                e.target.value = ("" + e.target.value).toUpperCase();
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.onDialogButtonClick}
              color="primary"
              className="add-child-dialog-confirm-button"
            >
              {t('Ok')}
            </Button>
            <Button
              onClick={this.onDialogClose}
              className="add-child-dialog-cancel-button"
            >
              {t('Cancel')}
            </Button>
          </DialogActions>
        </Dialog>
        {/* TODO: replace with the existing DOB dialog */}
        <Dialog
          open={isDobDialogOpen}
          onClose={this.onDobDialogClose}
          aria-labelledby="dob-form-dialog-title"
          className="dob-dialog"
        >
          <DialogTitle id="dob-form-dialog-title">
            {t('Date of birth confirmation')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("To confirm you are the parent/carer, please enter your child's date of birth.")}
            </DialogContentText>
            <div style={{ textAlign: 'center' }}>
              <DatePicker
                variant="inline"
                openTo="year"
                views={['year', 'month', 'date']}
                label={t('Date of Birth')}
                value={dob}
                minDate={ this.state.minDate }
                maxDate={ new Date() }
                initialFocusedDate={moment().subtract(14, 'years')}
                onChange={dob => this.setState({ dob })}
                format={dateFormat}
                autoComplete="off"
                disableFuture
                autoOk
                PopoverProps={{
                  anchorOrigin: { horizontal: 'center', vertical: 'center' },
                  transformOrigin: { horizontal: 'center', vertical: 'center' },
                }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.onDobDialogButtonClick}
              color="primary"
              className="dob-dialog-confirm-button"
            >
              {t('Ok')}
            </Button>
            <Button
              onClick={this.onDobDialogClose}
              className="dob-dialog-cancel-button"
            >
              {t('Cancel')}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withSnackbar(withTranslation()(AddChildDialog));
